import Vue from 'vue';
import axios from 'axios';
import LoadingManager from './loading';
import DonMessage from '@/util/message.js';
import language from '@/util/language';
import { E2E_INTL_HEADER } from '@/constant/common';
import _ from 'lodash';
import global from '@/global/global';

console.log('global', global);
const baseURL = global.BASE_URL;

const request_id_prefix = 'axios_request_index_';
let request_id_starter = Date.parse(new Date()) / 1000;

const service = axios.create({
  defaults: _.assign(axios.defaults, {
    baseURL: baseURL
  }),
  withCredentials: true
});

// http request 拦截器
service.interceptors.request.use((config) => {
  config.requestId = getRequestId();
  // 避免ie 缓存get 请求
  if (config.method == 'get') { // 判断get请求
    config.params = config.params || {};
    config.params.t = Date.parse(new Date()) / 1000; // 添加时间戳
  }

  const url = config.url;
  if ((url.indexOf('?') != -1)) { // post 请求需要 encode 查询参数的value
    encodeRequestURI(config);
  }

  config.headers[E2E_INTL_HEADER] = language; // 请求头add国际化header
  config.withCredentials = true;
  if(!config.skipLoading) {
    LoadingManager.add(config);
    delete config.skipLoading
  }
  return config;
},
(err) => {
  return Promise.reject(err);
}
);

function encodeRequestURI(config) {
  let url = config.url;
  const urlArr = url.split('?');
  if (urlArr.length > 1) {
    const params = urlArr[1].split('&');
    const paramArr = [];
    for (let i = 0; i < params.length; i++) {
      if (params[i].split('=')[1]) {
        // 参数的value 存在
        paramArr.push(params[i].split('=')[0] + '=' + encodeURIComponent(params[i].split('=')[1]));
      } else {
        // 参数的value 不存在
        paramArr.push(params[i].split('=')[0] + '=' + params[i].split('=')[1]);
      }
    }
    url = urlArr[0] + '?' + paramArr.join('&');
  }
  config.url = url;
}

// 给每个请求设置一个 requestId
function getRequestId() {
  return request_id_prefix + request_id_starter++;
}

// http response 拦截器
service.interceptors.response.use((response) => {
  LoadingManager.remove(response);
  let result = response;
  if (response.config.responseType == 'arraybuffer' || response.config.responseType == 'blob') {
    result = response;
  } else {
    result = response.data;
  }
  return result;
}, (error) => {
  // 接口错误状态处理，也就是说无响应时的处理

  if (error.response) {
    const { data, status } = error.response;
    const currentPath = window.vm.$route.path;
    switch (status) {
      case 401:
        if (currentPath != '/login' && currentPath != '/' && currentPath != '/login2' && currentPath != '/403') {
          DonMessage({
            message: window.vm.$t('system.login_expired'),
            type: 'error'
          });
          window.vm.$router.replace({
            name: 'login'
          });
        }
        break;
      default:
        DonMessage({
          message: data.message ? data.message : window.vm.$t('system.server_error_msg'),
          type: 'error'
        });
    }
    LoadingManager.remove(error.response);
  } else {
    if (error.stack.indexOf('Network') > -1) {
      DonMessage({
        message: window.vm.$t('system.network_error'),
        type: 'error'
      });
    } else if (error.stack.indexOf('timeout')) {
      DonMessage({
        message: window.vm.$t('system.network_timeout'),
        type: 'error'
      });
    }
    LoadingManager.removAll();
  }

  return Promise.reject(error); // 返回接口返回的错误信息
}
);

Vue.prototype.$http = service;

export default service;

export { baseURL };



// WEBPACK FOOTER //
// ./src/util/axios.js